import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-location-large',
  templateUrl: './icon-location-large.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconLocationLargeComponent {}
